import React from "react";
import { SummaryModuleTag } from "../styles/summaryStyles";

const ModuleTypeTag = ({ type }) => {
    let icon = "";
    let label = "";

    if (type === "redo") {
        icon = "fa-light fa-rotate-exclamation";
        label = "Re-Registration";
    } else if (type === "adjustment" || type === "credit") {
        icon = "fa-light fa-memo-circle-info";
        label = "Adjustment";
    } else if (type === "progression") {
        icon = "fa-light fa-arrow-progress";
        label = "Progression";
    }

    return (
        <SummaryModuleTag $type={type}>
            <i className={icon}></i>
            <span>{label}</span>
        </SummaryModuleTag>
    );
};

export default ModuleTypeTag;

